import { cn } from '@rocco/utils/cn';
import { CONTENT_CAP_PADDED } from '~/ui-rocco/pages/detail-shared';
import { ABOUT_PROJECT_ROW_ID } from '../hooks/use-book-meeting-accordion';
import { useAboutProject } from '../hooks/use-about-project';
import { AboutProjectRowContent } from './AboutProjectRowContent';
import { ProjectStats } from './ProjectStats';

/**
 * About the Project, as a section of its own above the numbered accordion:
 * the project's image beside its lead statement, description and spec table.
 * It used to be the accordion's (01) row and started collapsed; the reader
 * had to open the page's own description. On the accordion's gutters, so the
 * columns line up with the rows below.
 */
export const AboutProjectSection = () => {
    const { heading, contentHtml, specItems, hasAbout } = useAboutProject();
    if (!hasAbout) return null;

    return (
        <section
            // The summary's "Read more" anchor lands here, below the sticky nav.
            id={ABOUT_PROJECT_ROW_ID}
            className={cn(
                'w-full scroll-mt-24 max-md:px-5 md:px-[3rem]',
                'qhd:overflow-x-clip',
            )}
        >
            <div className={CONTENT_CAP_PADDED}>
                <AboutProjectRowContent
                    heading={heading}
                    contentHtml={contentHtml}
                    specItems={specItems}
                    afterCopy={<ProjectStats />}
                />
            </div>
        </section>
    );
};
